/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';

export default function initDatadogLogs() {
  const errors: string[] = [];

  if (!import.meta.env.VITE_DATADOG_CLIENT_TOKEN) {
    errors.push('DatadogLogs: VITE_DATADOG_CLIENT_TOKEN not provided!');
  }

  if (!import.meta.env.VITE_DATADOG_SITE) {
    errors.push('DatadogLogs: VITE_DATADOG_SITE not provided!');
  }

  if (!import.meta.env.VITE_DATADOG_SERVICE_NAME) {
    errors.push('DatadogLogs: VITE_DATADOG_SERVICE_NAME not provided!');
  }

  if (errors.length) {
    errors.forEach((err) => {
      console.error(err);
    });
    return;
  }

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string,
    site: import.meta.env.VITE_DATADOG_SITE,
    service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
    version: import.meta.env.VITE_RELEASE_VERSION ?? undefined,
    env: import.meta.env.VITE_ENV,
    forwardErrorsToLogs: true,
    silentMultipleInit: true,
  });
}
